import OButtonTween from "./OButtonTween";
import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";

export default class OCheckBoxTween extends OButtonTween {
    constructor(outTexture, atlas = null, json = null) {
        super(outTexture, atlas, null, null, null);

        this._gdConf = json;
        this._oType = OmyConst.OMY_CHECK_BOX_TWEEN;
        this._isChecking = true;

        this._activeState = { out: null, over: null, down: null, up: null };
        this._noActiveState = { out: null, over: null, down: null, up: null };

        if (json) {
            if (!json["active"])
                Omy.error("This object have not active state. Name:" + "button", json);
            this.addActiveState(json["active"]);

            if (!json["noActive"])
                Omy.error("This object have not active state. Name:" + "button", json);
            this.addNoActiveState(json["noActive"]);
        }
    }

    /**     * @public     */
    addActiveState(data) {
        this._activeState.out = data.out;
        this._activeState.over = data.over;
        this._activeState.down = data.down;
        this._activeState.up = data.up;
        if (this._isChecking)
            this.changeTextures(data.out, data.over, data.down, data.up);
    }

    /**     * @public     */
    addNoActiveState(data) {
        this._noActiveState.out = data.out;
        this._noActiveState.over = data.over;
        this._noActiveState.down = data.down;
        this._noActiveState.up = data.up;
        if (!this._isChecking)
            this.changeTextures(data.out, data.over, data.down, data.up);
    }

    destroy(options) {
        this._gdConf = null;
        this._activeState = null;
        this._noActiveState = null;
        return super.destroy(options);
    }

    _onUpHandler() {
        this._isChecking = !this._isChecking;
        this._checkState();
        super._onUpHandler();
    }

    _checkState() {
        if (this._isChecking)
            this.changeTextures(
                this._activeState.out, this._activeState.over,
                this._activeState.down, this._activeState.up
            );
        else
            this.changeTextures(
                this._noActiveState.out, this._noActiveState.over,
                this._noActiveState.down, this._noActiveState.up
            );
    }

    set isChecking(value) {
        this._isChecking = value;
        this._checkState();
    }

    get isChecking() {
        return this._isChecking;
    }
}
